var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative space-y-2"},[_c('FeatureUsage'),_c('EventTimeline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }